import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ItemProdutoEditarComponent } from "./item-produto-editar.component";
import { ItemProdutoEditarRoutingModule } from "./item-produto-editar-routing.module";

import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { ConfirmationService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputNumberModule } from "primeng/inputnumber";
import { InputMaskModule } from "primeng/inputmask";
import { TabViewModule } from "primeng/tabview";
import {TooltipModule} from 'primeng/tooltip';
import { DialogModule } from "primeng/dialog";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import {GalleriaModule} from 'primeng/galleria';
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { QRCodeModule } from "angularx-qrcode";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ItemProdutoEditarRoutingModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        DropdownModule,
        InputSwitchModule,
        InputNumberModule,
        InputMaskModule,
        TabViewModule,
        TooltipModule,
        DialogModule,
        FormatPipeModule,
        ProgressSpinnerModule,
        QRCodeModule
    ],
    providers: [ConfirmationService],
    declarations: [ItemProdutoEditarComponent]
})
export class ItemProdutoEditarModule { }
